import React from 'react';
import { Text } from '@fluentui/react-components';
import { Dismiss16Regular } from '@fluentui/react-icons';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Button } from '../../Button';
import { makeLinksClickable } from '../Chat.utils';
import './ChatInputCitedMessage.scss';

export interface ChatCitedMessage {
  fromDisplayName: string;
  createdDateTime: string;
  deletedDateTime: string | null;
  content: string;
}

export interface ChatInputCitedMessageProps {
  originalMessage: ChatCitedMessage;
  onCloseClick?: () => void;
}

export const ChatInputCitedMessage: React.FC<ChatInputCitedMessageProps> = ({
  originalMessage,
  onCloseClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="chatMessageCitation">
      <div className="inner">
        <div className="meta">
          <Text className="spacer" size={200}>
            {originalMessage.fromDisplayName}
          </Text>
          <Text size={200} className="date">
            {moment(originalMessage.createdDateTime).format('LLL')}
          </Text>
          {onCloseClick && (
            <Button
              className="closeButton"
              data-testid="closeButton"
              icon={<Dismiss16Regular />}
              appearance="transparent"
              onClick={onCloseClick}
              aria-label={t('classbook:chat:close_citation', { defaultValue: 'Zitat schließen' })}
            />
          )}
        </div>
        <div className={cn('messageBody', { deleted: originalMessage.deletedDateTime !== null })}>
          <Text>
            {originalMessage.deletedDateTime === null
              ? makeLinksClickable(originalMessage.content)
              : t('courses:chat:message_deleted', {
                  defaultValue: 'Diese Nachricht wurde gelöscht.',
                })}
          </Text>
        </div>
      </div>
    </div>
  );
};
